import React from "react"
import Helmet from "react-helmet"
import { graphql, useStaticQuery } from "gatsby"

import Navbar from "./navbar/Navbar"
import Footer from "./Footer"

const TemplateWrapper = ({ children, title, description }) => {
  const siteQuery = useStaticQuery(
    graphql`
      query SITE_METADATA_QUERY {
        site {
          siteMetadata {
            title
            description
          }
        }
      }
    `
  )

  const layoutTitle = title
    ? `${title} | Looking For Sponsor`
    : siteQuery.site.siteMetadata.title
  const layoutDescription = description
    ? description
    : siteQuery.site.siteMetadata.description

  return (
    <div>
      <Helmet>
        <html lang="en" className="has-navbar-fixed-top" />
        <title>{layoutTitle}</title>
        <meta name="description" content={layoutDescription} />

        <link
          rel="icon"
          type="image/png"
          href="/img/favicon-32x32.png"
          sizes="32x32"
        />
        <link
          rel="icon"
          type="image/png"
          href="/img/favicon-16x16.png"
          sizes="16x16"
        />

        <meta property="og:type" content="website" />
        <meta property="og:title" content={layoutTitle} />
        <meta property="og:description" content={layoutDescription} />
        <meta property="og:url" content="https://lookingforsponsor.com" />
        <meta
          property="og:image"
          content="https://www.lookingforsponsor.com/img/og-image-default.jpg"
        />

        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content={layoutTitle} />
        <meta name="twitter:description" content={layoutDescription} />
        <meta
          name="twitter:image"
          content="https://www.lookingforsponsor.com/img/twitter-image-default.jpg"
        />
      </Helmet>
      <Navbar />
      <div>{children}</div>
      <Footer />
    </div>
  )
}

export default TemplateWrapper
